import { HYDRATE } from "next-redux-wrapper";
import { INCREMENT_COUNTER, DECREMENT_COUNTER } from "./type";

const initialState = {
  server: "",
  client: "",
  counter: 0,
};

// Creating the reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case HYDRATE:
      return {...state, ...action.payload};
    case INCREMENT_COUNTER:
      return { ...state, counter: action.payload };
    case DECREMENT_COUNTER:
      return { ...state, counter: action.payload };
    default:
      return state;
  }
}
